module.exports = __webpack_public_path__ + "img/crowns.a90d50a1.svg";